import { appPlaygroundPath } from '@/utils/constants';

export const isInPlayground = () => {
  const path = window.location.pathname;

  // Check for /o/{orgId}/playground pattern (with optional /r/{runId})
  const orgPlaygroundPattern = new RegExp(
    `/o/[\\w-]+/${appPlaygroundPath}(/r/[\\w-]+)?$`
  );
  // Check for /prompts/*/playground pattern
  const promptsPlaygroundPattern = /\/prompts\/[^/]+\/playground/;

  return orgPlaygroundPattern.test(path) || promptsPlaygroundPattern.test(path);
};
